const loginType = {
  '/login-poll-results': 0,
  '/login-participants-results': 1
};

export { loginType };
